module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_L4-d5fc00a14ee5ef217a1ae63ebe6816be.webp";